import ZoomControlsContainer from './ZoomControlsContainer';

export default ZoomControlsContainer;
